'use client'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay, Keyboard } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default function BusinessGrow() {
   const logos = [
      '/assets/svg/technologies/careboarding_icon.svg',
      '/assets/svg/technologies/magicShoes_icon.svg',
      // '/assets/svg/technologies/robotmaker_icon.svg',
      '/assets/svg/technologies/proTrade_icon.svg',
      '/assets/svg/technologies/eg_innovations_icon.svg',
   ]

   return (
      <section className="page_top_section2 section_primary_bg pb-5 pt-5">
         <div className="container">
            <div className="top_section_content">
               <div className="section_heading_title top_section_heading">
                  We’ve Helped 200+ Business Grow
               </div>
               <div className="top_section_details">
                  From initial stage start-up growth strategies to assisting
                  established businesses, we have done it all! The outcomes
                  speak for themselves. Our services work.
               </div>
            </div>
            <div className="stats-section my-md-4 my-0">
               <div className="row text-center justify-content-center">
                  <div className="col-lg-2 col-6 mt-0">
                     <div className="stat-box d-flex align-items-center justify-content-center flex-column">
                        <div className="stat-icon d-flex justify-content-center align-items-center">
                           <img
                              className="stat-icon-img"
                              src="/assets/svg/technologies/brain_icon.svg"
                              height="42"
                              width="42"
                              alt="brain"
                           />
                        </div>
                        <div className="top_section_heading">50+</div>
                        <div className="stat-text">Developers Team</div>
                     </div>
                  </div>
                  <div className="col-lg-3 col-6 mt-0">
                     <div className="stat-box d-flex align-items-center justify-content-center flex-column">
                        <div className="stat-icon d-flex justify-content-center align-items-center">
                           <img
                              className="stat-icon-img"
                              src="/assets/svg/technologies/globe_icon.svg"
                              height="36"
                              width="36"
                              alt="globe"
                           />
                        </div>
                        <div className="top_section_heading">25+</div>
                        <div className="stat-text">Countries Served</div>
                     </div>
                  </div>
                  <div className="col-lg-2 col-6 mt-5 mt-lg-0">
                     <div className="stat-box d-flex align-items-center justify-content-center flex-column">
                        <div className="stat-icon d-flex justify-content-center align-items-center">
                           <img
                              className="stat-icon-img"
                              src="/assets/svg/technologies/officialTick_icon.svg"
                              height="42"
                              width="42"
                              alt="tick"
                           />
                        </div>
                        <div className="top_section_heading">200+</div>
                        <div className="stat-text">Project Delivered</div>
                     </div>
                  </div>
                  <div className="col-lg-3 col-6 mt-5 mt-lg-0">
                     <div className="stat-box d-flex align-items-center justify-content-center flex-column">
                        <div className="stat-icon d-flex justify-content-center align-items-center">
                           <img
                              className="stat-icon-img"
                              src="/assets/svg/technologies/greenTelegram_icon.svg"
                              height="42"
                              width="42"
                              alt="telegram"
                           />
                        </div>
                        <div className="top_section_heading">95%</div>
                        <div className="stat-text">Talent Retention Rate</div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="box_section d-none d-lg-flex row">
               <div className="logo_box col-lg-2 col-md-4 col-sm-6 col-12 logo_box_first">
                  <img src="/assets/svg/technologies/careboarding_icon.svg" />
               </div>
               <div className="logo_box col-lg-2 col-md-4 col-sm-6 col-12">
                  <img src="/assets/svg/technologies/magicShoes_icon.svg" />
               </div>
               {/* <div className="logo_box col-lg-2 col-md-4 col-sm-6 col-12">
                  <img src="/assets/svg/technologies/robotmaker_icon.svg" />
               </div> */}
               <div className="logo_box col-lg-2 col-md-4 col-sm-6 col-12">
                  <img src="/assets/svg/technologies/proTrade_icon.svg" />
               </div>
               <div className="logo_box col-lg-2 col-md-4 col-sm-6 col-12 logo_box_last">
                  <img src="/assets/svg/technologies/eg_innovations_icon.svg" />
               </div>
            </div>
            <div className="d-block d-lg-none">
               <Swiper
                  modules={[Autoplay, Pagination, Navigation, Keyboard]}
                  autoplay={{
                     delay: 3000,
                     disableOnInteraction: false,
                  }}
                  slidesPerView={1}
                  spaceBetween={30}
                  grabCursor={true}
                  freeMode={false}
                  loop={true}
                  mousewheel={false}
                  keyboard={{ enabled: true }}
                  speed={600}
                  pagination={{
                     clickable: true,
                     renderBullet: (index, className) =>
                        `<span class="${className} custom-bullet"></span>`,
                  }}
                  navigation={{
                     nextEl: '.custom-clients-wrap-next-btn',
                     prevEl: '.custom-clients-wrap-prev-btn',
                  }}
                  breakpoints={{
                     769: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                     },
                     992: {
                        slidesPerView: 2,
                        spaceBetween: -50,
                     },
                     1200: {
                        slidesPerView: 3,
                        spaceBetween: 85,
                     },
                     1440: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                     },
                  }}
               >
                  {logos.map((src, i) => (
                     <SwiperSlide
                        className="d-flex justify-content-center align-items-center"
                        key={i}
                     >
                        <div className="logo_box">
                           <img src={src} alt={`Client logo ${i}`} />
                        </div>
                     </SwiperSlide>
                  ))}
               </Swiper>
            </div>
         </div>
      </section>
   )
}
